import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link, useLocation } from "react-router-dom";
// import { camera, cancel, chatcurve, chatcurve1, enterchat, file, physicianchat, uploadfile } from "../Constant/Index";
import {
	getPatientchat,
	getPhysicianchat,
	patientSendmessageapi,
	physicianSendmessageapi,
} from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import Pusher from "pusher-js";
import {
	camera,
	cancle,
	chatcurve,
	chatcurve1,
	enterchat,
	file,
	physicianchat,
	uploadfile,
} from "../Constant/Index";
import ChatComponent from "../Components/ChatComponent";

const UserChat = () => {
	let { state } = useLocation();
	return (
		<>
			{/* <Header />
      <PageHeader pagename="Chat" /> */}
			<ChatComponent tabName={state?.tabName} />
			{/* <Footer /> */}
		</>
	);
};

export default UserChat;
